import { render, staticRenderFns } from "./combo-card.vue?vue&type=template&id=30f1c0b1&scoped=true"
import script from "./combo-card.vue?vue&type=script&lang=js"
export * from "./combo-card.vue?vue&type=script&lang=js"
import style0 from "./combo-card.vue?vue&type=style&index=0&id=30f1c0b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1c0b1",
  null
  
)

export default component.exports